import { Component, OnInit } from '@angular/core';
import { getTenantLetterAssets } from '../../../_shared/utils/letter-assets';
import { getTenantConfig } from '../../../_shared/utils/tenant-context';
import {
  Delivery,
  InvoicesList,
  Personen,
  SingleInvoice,
  SingleJob,
  StatusButtons
} from "../../../_shared/interfaces";
import {
  ClrCheckboxModule,
  ClrDatagridModule,
  ClrDatagridSortOrder,
  ClrIconModule, ClrModalModule,
  ClrTabsModule,
  ClrTooltipModule
} from "@clr/angular";

import { environment as env } from "../../../../environments/environment";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import {CurrencyPipe, DatePipe, DecimalPipe, formatCurrency, JsonPipe, NgIf} from "@angular/common";
import {
  AlertService, ConditionStoreService,
  DeliveryStoreService,
  FileStoreService,
  IAlertType,
  InvoicesStoreService, JobsStoreService, StaffStoreService, XinvoiceGeneratorService
} from "../../../_shared/services";
import { InvoicePaidComponent } from "./invoice-paid/invoice-paid.component";
import { InvoiceDuedateComponent } from "./invoice-duedate/invoice-duedate.component";
import { InvoiceEditPositionComponent } from "./invoice-edit-position/invoice-edit-position.component";
import { InvoiceDetailsDocumentsComponent } from "./invoice-details-documents/invoice-details-documents.component";
import {ClarityIcons, exclamationTriangleIcon, infoCircleIcon, pencilIcon, timesCircleIcon} from "@cds/core/icon";

import moment from "moment";
import { saveAs } from 'file-saver';
import PackageJson from "../../../../../package.json";

@Component({
  selector: 'app-invoice-details',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    JsonPipe,
    NgIf,
    ClrTabsModule,
    ClrDatagridModule,
    ClrCheckboxModule,
    CurrencyPipe,
    ClrIconModule,
    ClrTooltipModule,
    DecimalPipe,
    InvoicePaidComponent,
    InvoiceDuedateComponent,
    InvoiceEditPositionComponent,
    InvoiceDetailsDocumentsComponent,
    ClrModalModule
  ],
  templateUrl: './invoice-details.component.html',
  styleUrl: './invoice-details.component.sass'
})
export class InvoiceDetailsComponent implements OnInit {
  praefix: string = '';
  invoiceId: string = '';
  jobId: number = 0;
  projectId: string = ''
  deliveryId: number = 0;
  invoices: SingleInvoice = new SingleInvoice();
  positions: InvoicesList[] = [];
  resetPositions: Delivery[] = [];
  person: Personen[] = [];
  xInvoice: Object = {};
  job: SingleJob = new SingleJob();
  loading1: boolean = true;
  loading2: boolean = true;
  printInvoice: boolean = false;
  statusLabel: string = 'label-light-blue';
  statusText: string = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  staffPhone: string = '';
  payment_condition: any = "";
  payment_term_date: number = 0;
  payment_term_value: number = 0;
  selected: [] = [];
  nettoTotal: number = 0;
  vatFactor: number = 0;
  skonto: number = 0;
  editDueDate: boolean = false;
  editAmount: boolean = true;
  editPos: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  positionId: number = 0;
  partId: number = 0;
  devMode: boolean;
  private readonly tenantConfig = getTenantConfig();

  public ppsVersion: string = PackageJson.version;

  descSort = ClrDatagridSortOrder.ASC;

  statusButtons: StatusButtons[] = [
    { state: 'draft', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'partially', display: 'Teilbezahlt', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Fällig', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'paid', display: 'Bezahlt', label: 'alert-success', icon: 'check-circle'},
    { state: 'cancelled', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  // Für Ausdruck
  basic: boolean = false;
  clrModalSize: string = 'xl';
  documentDefinition = getTenantLetterAssets().a4Letter;

  constructor(
    private invss: InvoicesStoreService,
    private jobss: JobsStoreService,
    private delss: DeliveryStoreService,
    private staffss: StaffStoreService,
    private filess: FileStoreService,
    private condss: ConditionStoreService,
    private xinvgs: XinvoiceGeneratorService,
    private router: Router,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(infoCircleIcon, timesCircleIcon, pencilIcon, exclamationTriangleIcon)
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.praefix = params.get('praefix') ?? '';
    this.invoiceId = params.get('invid') ?? '';
    this.loadInvoice(parseInt(this.praefix), parseInt(this.invoiceId));
  }


  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(orderstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === orderstatus)
  };

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }

  loadInvoice(praefix: number, number: number) {
    this.invss.getSingleInvoice(praefix, number).subscribe({
      next: data1 => {
        if (!data1 || !data1.object) {
          this.alertDispatcher.show({
            message: 'Keine Invoicedaten gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        console.log(typeof data1.object);
        console.table(data1.object);
        this.invoices = data1.object;
      },
      complete: () => {
        // console.table(this.invoices);
        this.projectId = this.invoices.project_id;
        this.jobId = this.invoices.job_id ?? 0;
        this.deliveryId = this.invoices.delivery_id ?? 0;

        this.staffStatus(this.invoices.employee_phm ?? 0);

        // Check, ob Kunde aus Deutschland -> VAT
        if (this.invoices.vat_id.startsWith("DE")) { this.vatFactor = 1.19 } else { this.vatFactor = 1 }

        // Daten aus Job ergänzen
        this.loadJob(this.projectId, this.jobId);

        // Gelieferte Positionen laden
        this.loadDeliveriesPositions(this.projectId,this.deliveryId);
        this.loadInvoicesPositions(this.praefix + '.' + this.invoiceId);

        // Status gestalten
        const statusline = this.findButtonStatus(this.invoices.status, this.statusButtons);
        this.statusLabel = this.statusButtons[statusline].label;
        this.statusText = this.statusButtons[statusline].display;

        // Zahlungseingang startet immer in Anzeige-Modus
        this.editAmount = false;

        // Check, ob Land des Kunden angegeben ist
        if (!this.invoices.country) {
          this.alertDispatcher.alertConfig.message = 'Bitte Land ergänzen!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          this.printInvoice = false;
        } else {
          this.printInvoice = true;

          // Check, ob Fälligkeitsdatum gesetzt
          if (!this.invoices.dateII) {
            this.alertDispatcher.alertConfig.message = 'Bitte Fälligkeitsdatum ergänzen!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
            this.printInvoice = false;
          } else {
            this.printInvoice = true;
          }
        }

        this.loading1 = false;
      },
      error: () => {
        return
      }
    });
  }

  loadInvoicesPositions(invoiceID: string) {
    let factor: number;
    this.nettoTotal = 0;
    this.invss.getInvoicesPositions(invoiceID, 0, 0).subscribe({
      next: data2 => {
        this.positions = data2.object;

        this.positions.forEach((item) => {
          if (item.number_of_pieces == 0) { factor = 1 } else { factor = item.number_of_pieces }
          this.nettoTotal += factor * parseFloat(item.selling_price);
        })
      },
      complete: () => {
        this.updateAmount(this.nettoTotal*this.vatFactor, this.nettoTotal*this.vatFactor);
        this.loading2 = false;
      },
      error: () => {
        return
      }
    })
  }

  createInvoice(positions: any[]) {
    let invoiceValue = 0.00;
    let benennung = '';
    let faelligkeit = '';
    let serialkostenstelle = '';
    let company = this.invoices.company_name;
    if (this.invoices.department) company += '\n' + this.invoices.department;

    // Die Briefvorlage ist ein gemeinsames Objekt aller Belegarten; jede
    // schreibt ihre Knoten hinein. Die Rechnung macht aus content[1] einen
    // Spaltenknoten -- damit Lieferschein und Angebot weiterhin einen
    // Textknoten vorfinden, arbeitet sie auf einer Kopie der Knotenliste.
    const vorlage = getTenantLetterAssets().a4Letter;
    this.documentDefinition = {
      ...vorlage,
      info: { ...vorlage.info },
      content: vorlage.content.map((node: any) => (
        node.table ? { ...node, table: { ...node.table } } : { ...node }
      )),
    };
    const isStorno = !!this.invoices.cancels_invoice_no;
    if (isStorno) {
      faelligkeit = 'Sofort (Verrechnung/Rückerstattung zur Rechnung ' + this.invoices.cancels_invoice_no + ')';
    } else if (this.payment_term_value > 0) {
      faelligkeit = 'mit ' + this.payment_term_value + '% Skonto am ' + this.calculateDiscountDate(this.payment_term_date) + '\nohne Abzug am ' + moment(this.invoices.dateII).format("DD.MM.yyyy")
    } else {
      faelligkeit = moment(this.invoices.dateII).format("DD.MM.yyyy")
    }

    let posTable = [[{ text: 'Pos.'}, { text: 'Bezeichnung'}, { text: 'Zeichnung', colSpan: 1, style: '' }, { text: 'Lieferschein'}, { text: 'Anzahl'}, { text: 'Preis/St.', alignment: 'right', noWrap: true}, { text: 'Gesamtpreis', alignment: 'right'}]];

    positions.forEach(position => {
      serialkostenstelle = '';
      benennung = position.name;

      if ((position.serial_nr != 'null') && (position.serial_nr != '') && (position.serial_nr != 'NULL')) serialkostenstelle = "Kennzeichnung: " + position.serial_nr;
      if ((position.controlling_nr != 'null') && (position.controlling_nr != '') && (position.controlling_nr != 'NULL')) serialkostenstelle = "Kostenstelle: " + position.controlling_nr;
      if (((position.serial_nr != 'null') && (position.serial_nr != '') && (position.serial_nr != 'NULL')) && ((position.controlling_nr != 'null') && (position.controlling_nr != '') && (position.controlling_nr != 'NULL'))) serialkostenstelle = "Kennzeichnung: " + position.serial_nr + "\nKostenstelle: " + position.controlling_nr;
      if (position.taric && position.taric !== "0") benennung += '\n(Zolltarifnummer: ' + position.taric + ')';

      // Angebotssumme berechnen
      if (position.technology) {
        invoiceValue = invoiceValue + parseFloat(position.selling_price);
      } else {
        invoiceValue = invoiceValue + (position.number_of_pieces*parseFloat(position.selling_price));
      }
      switch(position.part) {
        case 0: {
          if (position.technology) {
            posTable.push(
              [ position.position, benennung, position.technical_drawing, this.invoices.project_id + ".0004." + this.invoices.delivery_id, '', '', { text: formatCurrency(1 * position.selling_price, 'de', 'EUR', 'EUR'), alignment:'right'} ]
            );
          } else {
            posTable.push(
              [ position.position, benennung, position.technical_drawing, this.invoices.project_id + ".0004." + this.invoices.delivery_id, position.number_of_pieces, { text: formatCurrency(position.selling_price, 'de', '', 'EUR'), alignment:'right'}, { text: formatCurrency(position.number_of_pieces * position.selling_price, 'de', 'EUR', 'EUR'), alignment:'right'}  ]
            );
          }
          break;
        }
        default: {
          if (position.technology) {
            posTable.push(
              [ position.position + '.' + position.part, benennung, position.technical_drawing, this.invoices.project_id + ".0004." + this.invoices.delivery_id, '', '', { text: formatCurrency(1 * position.selling_price, 'de', 'EUR', 'EUR'), alignment: 'right' }  ]
            );
          } else {
            posTable.push(
              [ position.position + '.' + position.part, benennung, position.technical_drawing, this.invoices.project_id + ".0004." + this.invoices.delivery_id, position.number_of_pieces, { text: formatCurrency(position.selling_price, 'de', '', 'EUR'), alignment: 'right' }, { text: formatCurrency(position.number_of_pieces * position.selling_price, 'de', 'EUR', 'EUR'), alignment: 'right' }  ]
            );
          }
          break;
        }
      }
      if (serialkostenstelle) {
        posTable.push(
          [ { text: "" }, { text: serialkostenstelle, colSpan: 3, style: 'small' }, { text: ""}, { text: "" }, { text: "" }, { text: "" }, { text: "" } ]
        )}
      if (position.remarks) {
        posTable.push(
          [ { text: "" }, { text: "" }, { text: "" }, { text: position.remarks, colSpan: 3, style: 'small' }, { text: "" }, { text: "" }, { text: "" } ]
        )}
    });

    this.documentDefinition.info.title = 'PPS Rechnung';
    this.documentDefinition.info.subject = 'RECHNUNG ' + this.projectId + '.0004.' + this.deliveryId;
    this.documentDefinition.info.revison = this.ppsVersion;

    (this.documentDefinition.content[0] as any).columns[0].text = company + '\n' + this.invoices.street + '\n' + this.invoices.postcode + ' ' + this.invoices.city;
    if(this.invoices.country && (this.invoices.country != 'Deutschland')) {
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + this.invoices.country
    }
    // Der Ersteller der Rechnung (invoices.employee_phm, seit dem RMS-Stand
    // vom 22.09.2026 der Anleger statt des Projektverantwortlichen) mit dem
    // Rechnungspostfach des Mandanten -- Rueckfragen zur Rechnung sollen dort
    // ankommen, nicht im persoenlichen Postfach.
    const contactEMail = this.tenantConfig.invoiceContactEmail ?? this.staffEMail;
    (this.documentDefinition.content[0] as any).columns[2].text = this.tenantConfig.letterCity + ', ' + moment(this.invoices.dateI).format("DD.MM.yyyy") + '\n\nIhr Ansprechpartner:\n' + this.staffFirstName + ' ' + this.staffLastName + '\n' + contactEMail;
    const invoiceLabel = this.invoices.cancels_invoice_no ? 'STORNORECHNUNG' : 'RECHNUNG';
    const kopfzeile = invoiceLabel + ' ' + this.invoices.praefix + '.' + String(this.invoices.number).padStart(4, '0');
    const bestellzeilen = 'Ihre Bestellung: ' + this.invoices.order_id + '\nIhre USt-IdNr.: ' + this.invoices.vat_id + '\nJob-Nr.: ' + this.invoices.project_id + '.0006.' + this.jobId;

    // Kopf und Bestellzeilen links, rechts daneben die Lieferanschrift.
    // Die Datumsspalte des Anschriftenblocks beginnt bei 230 + 10 + 70 + 10
    // = 320 und hat einen Innenrand von 30, ihr Text steht also bei 350.
    // Dieser Knoten hat selbst 30 Rand; die linke Spalte ist deshalb 310
    // breit, damit die Lieferanschrift bei 30 + 310 + 10 = 350 buendig unter
    // "Ihr Ansprechpartner" steht. Die vertikalen Raender sind so gewaehlt,
    // dass content[1] und content[2] zusammen denselben Platz einnehmen wie
    // zuvor (Vorlage: -30 / +30).
    const lieferanschrift = this.lieferanschriftFuerBogen();
    this.documentDefinition.content[1] = {
      columns: [
        { width: lieferanschrift ? 310 : '*', stack: [
          { text: kopfzeile, style: 'header' },
          { text: bestellzeilen, style: 'small' },
        ]},
        ...(lieferanschrift ? [{ width: 200, stack: [
          { text: 'Lieferanschrift', style: 'header' },
          { text: lieferanschrift, style: 'small' },
        ]}] : []),
      ],
      columnGap: 10,
      margin: [30, -30],
    };
    this.documentDefinition.content[2] = { text: '', margin: [30, 30] };

    // Anrede wie auf dem Altbogen. Rechnungen gehen an die Buchhaltung, nicht
    // an eine Person -- deshalb immer "Damen und Herren", anders als beim
    // Angebot. Eine Stornorechnung berechnet nichts, sie hebt auf.
    this.documentDefinition.content[3] = {
      ...this.documentDefinition.content[3],
      text: 'Sehr geehrte Damen und Herren,\n\n' + (isStorno
        ? 'zur Rechnung ' + this.invoices.cancels_invoice_no + ' stornieren wir nachfolgende Positionen:'
        : 'wir erlauben uns, für die vertraglich vereinbarten Leistungen gemäß Ihrer Bestellung nachfolgende Positionen zu berechnen:'),
    };

    // Bezeichnung nimmt die Restbreite: die Tabelle fuellt damit die Seite
    // und endet rechts buendig mit der Summenaufstellung darunter. Ohne diese
    // Zeile haette sie nur Inhaltsbreite -- oder die Breiten, die zuletzt ein
    // anderer Beleg in die gemeinsame Vorlage geschrieben hat.
    (this.documentDefinition.content[4] as any).table.widths = [ 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto' ];
    (this.documentDefinition.content[4] as any).table.headerRows = 1;
    (this.documentDefinition.content[4] as any).table.body = posTable;

    // VAT handling is driven by vatFactor (set during invoice load).
    // Country can be "DE" or "Deutschland", therefore don't hard-bind to one string.
    if (this.vatFactor > 1) {
      this.documentDefinition.content[5] = {
        unbreakable: true,
        stack: [
          {
            text: '', width: '*'
          },
          {
            layout: 'lightHorizontalLines',
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              // headerRows: 1,
              widths: ["auto", "*"],
              body: [
                [{text: "netto", style: 'table'}, {
                  text: formatCurrency(invoiceValue, 'de', 'EUR', 'EUR'),
                  alignment: 'right',
                  style: 'table'
                }],
                [{
                  text: "MWSt. (19%)",
                  style: 'table'
                }, {
                  text: formatCurrency(invoiceValue * 0.19, 'de', 'EUR', 'EUR'),
                  alignment: 'right',
                  style: 'table'
                }],
                [{
                  text: "Brutto",
                  style: 'table',
                  bold: true,
                }, {
                  text: formatCurrency(invoiceValue * 1.19, 'de', 'EUR', 'EUR'),
                  alignment: 'right',
                  style: 'table',
                  bold: true
                }],
              ]
            },
            width: '35%',
            margin: [30, 0]
          }
        ]
      } as any;
    } else {
      this.documentDefinition.content[5] = {
        unbreakable: true,
        stack: [
          {
            text: '', width: '*'
          },
          {
            layout: 'lightHorizontalLines',
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              // headerRows: 1,
              widths: ["auto", "*"],
              body: [
                [{text: "netto", style: 'table'}, {
                  text: formatCurrency(invoiceValue, 'de', 'EUR', 'EUR'),
                  alignment: 'right',
                  style: 'table'
                }],
                [{
                  text: "MWSt. (0,00%)",
                  style: 'table'
                }, {
                  text: formatCurrency(invoiceValue * 0, 'de', 'EUR', 'EUR'),
                  alignment: 'right',
                  style: 'table'
                }],
                [{
                  text: "Brutto",
                  style: 'table',
                  bold: true,
                }, {
                  text: formatCurrency(invoiceValue * 1, 'de', 'EUR', 'EUR'),
                  alignment: 'right',
                  style: 'table',
                  bold: true
                }],
              ]
            },
            width: '35%',
            margin: [30, 0]
          }
        ]
      } as any;
    }

    const zahlungsBody = isStorno
      ? [
          ['Zahlungsbedingungen:', 'Sofort fällig'],
          ['Fälligkeit:', faelligkeit],
          ['', ''],
          ['Storno zu:', 'Rechnung ' + this.invoices.cancels_invoice_no]
        ]
      : [
          ['Zahlungsbedingungen:', this.payment_condition],
          ['Fälligkeit:', faelligkeit],
          ['', ''],
          ['', 'Nach Ablauf dieses Termins berechnen wir Verzugszinsen mit 5%-Punkten über dem jeweiligen Diskontsatz der Bundesbank.']
        ];

    this.documentDefinition.content[6] = {
      stack: [
        {
          layout: 'noBorders',
          table: { body: zahlungsBody },
          style: 'normal',
          margin: [30, 10]
        },
        { text: 'Leistungsdatum entspricht dem Rechnungsdatum', style: 'fett', margin: [30, 10] },
        ...(!isStorno ? [{ text: 'Eigentumsvorbehalt\n\nUnsere Waren bzw. Leistungen bleiben unser Eigentum bis zur vollständigen Bezahlung aller aus der Geschäftsverbindung entstandenen Verbindlichkeiten, auch bei Weiterveräußerung  und Konkurs. Sie treten etwaige Ansprüche aus Weiterveräußerung schon jetzt an uns ab. Wir haften nur in Höhe des oben angebotenen Umfanges. Reklamationen werden nur innerhalb von 10 Tagen nach Lieferung durch uns anerkannt  (soweit nichts anderes vereinbart). Der Eigentumsvorbehalt gilt als vertraglich vereinbart, wenn hierzu keine schriftliche Einrede erfolgt. ', style: 'small', width: 520, margin: [30, 20] }] : [])
      ]
    } as any;
    this.documentDefinition.content.splice(7);

    this.generatePdf();
  }

  generatePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);

    documentGenerator.getDataUrl((dataUrl: string) => {
      const targetElement = document.querySelector('#documentContainer');
      targetElement!.innerHTML = '';

      if (!targetElement) {
        this.alertDispatcher.alertConfig.message = 'PDF-Container nicht gefunden!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
        return; // Exit the function if the element doesn't exist
      }

      const pdfIframe = document.createElement('iframe');
      pdfIframe.src = dataUrl;
      pdfIframe.width = '100%';
      pdfIframe.height = '100%';
      targetElement.appendChild(pdfIframe);
    })
  }

  updateInvoice(done: boolean) {
    this.editPos = 1;
    this.loadInvoice(parseInt(this.praefix), parseInt(this.invoiceId));
  }

  isDraft(): boolean {
    return (this.invoices.status || '') === 'draft';
  }

  isCancellable(): boolean {
    const s = (this.invoices.status || '').toLowerCase();
    return s !== 'draft' && s !== 'cancelled';
  }

  deleteInvoice(projectID: string, praefix: string, invoiceID: string, deliveryID: number) {
    if (!this.isDraft()) {
      this.alertDispatcher.show({
        message: 'Nur Rechnungs-Entwürfe können gelöscht werden. Verwenden Sie "Stornieren" für gebuchte Rechnungen.',
        clrAlertType: IAlertType.WARNING
      }, 6000);
      return;
    }
    if (this.devMode) console.log('Projekt: ' + projectID + ' Rechnungsnummer: ' + praefix + '.' + invoiceID);
    if (confirm('Wollen Sie diesen Rechnungs-Entwurf wirklich löschen?\n\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.invss.deleteInvoice(praefix, invoiceID)
        .subscribe({
          next: () => {
            this.router.navigate(['/delivery/details/', projectID, this.jobId, deliveryID]);
          },
          error: () => {
            return;
          }
        });
    }
  }

  cancelInvoice(projectID: string, praefix: string, invoiceID: string, deliveryID: number) {
    if (!this.isCancellable()) {
      return;
    }
    if (confirm(
      'Wollen Sie die Rechnung ' + praefix + '.' + invoiceID.padStart(4, '0') + ' wirklich stornieren?\n\n' +
      'Es wird eine Stornorechnung mit eigener Nummer erstellt.\n' +
      'Der dazugehörige Lieferschein wird wieder auf offen gesetzt.\n\n' +
      'Hinweis: Falls die Ware zurückgegeben wurde, bitte anschließend eine manuelle Warehouse-Einbuchung vornehmen.\n\n' +
      'Diese Aktion kann nicht rückgängig gemacht werden!'
    )) {
      this.invss.cancelInvoice(praefix, invoiceID)
        .subscribe({
          next: (response: any) => {
            const stornoPraefix = response?.praefix ?? praefix;
            const stornoNumber  = response?.message ?? invoiceID;
            this.alertDispatcher.show({
              message: 'Stornorechnung ' + stornoPraefix + '.' + String(stornoNumber).padStart(4, '0') + ' wurde erstellt.',
              clrAlertType: IAlertType.SUCCESS
            }, 6000);
            this.router.navigate(['/invoice/details/', stornoPraefix, stornoNumber]);
          },
          error: () => {
            return;
          }
        });
    }
  }


  loadJob(projectID: string, jobID: number){
    this.jobss.getSingleJob(projectID, jobID)
      .subscribe({
        next: data => {
          this.job = data.object;
        },
        complete: () => {
          this.loading1 = false;

          if (this.job.invoice_vat_id.length < 10) {
            this.alertDispatcher.alertConfig.message = 'Bitte UStIDNr. des Rechnungsemfängers prüfen!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          }

          //Bedingungen ermitteln
          this.payment_condition = this.getCondition(this.job.cond_payment, 2);
        },
        error: () => {
          return
        }
      });
  }

  loadDeliveriesPositions(projectID: string, deliveryID: number) {
    this.delss.getDeliveryPositions(projectID, 0, deliveryID, '0', '0').subscribe({
      next: data => {
        this.resetPositions = data.object;
      },
      complete: () => {},
      error: () => {
        return
      }
    })
  }

  /**
   * Die Lieferanschrift fuer den Rechnungsbogen, oder '' wenn der Job keine
   * hat.
   *
   * Quelle ist der Job (get_single_job liefert delivery_* mit). Gezeigt wird
   * sie immer, auch wenn sie mit der Rechnungsanschrift uebereinstimmt --
   * der Empfaenger soll auf dem Bogen sehen, wohin geliefert wurde, ohne
   * das aus dem Fehlen eines Blocks schliessen zu muessen.
   */
  private lieferanschriftFuerBogen(): string {
    const job = this.job;
    if (!job.delivery_company && !job.delivery_street) {
      return '';
    }

    const zeilen = [job.delivery_company, job.delivery_department, job.delivery_street,
      ((job.delivery_postcode ?? '') + ' ' + (job.delivery_city ?? '')).trim()];
    const land = (job.delivery_country ?? '').trim().toLowerCase();
    if (land && !['deutschland', 'de', 'germany'].includes(land)) {
      zeilen.push(job.delivery_country);
    }
    return zeilen.filter(z => z && z.trim()).join('\n');
  }

  staffStatus(staffId: number){
    this.staffss.getStaffById(staffId)
      .subscribe({
        next: staff => {
          const member = staff?.object?.[0];
          if (!member) {
            return;
          }
          this.staffFirstName = member.firstname;
          this.staffLastName = member.lastname;
          this.staffEMail = member.email;
          this.staffPhone = member.phone;
        },
        complete: () => {
          if (this.devMode) console.log('StaffID ist ' + staffId);
        }
      })
  }

  getCondition(condID: number, condType:number){
    let delay: number = 0;
    let discount: number = 0;
    if (condID == 0) {
      this.payment_condition = "---";
    } else {
      this.condss.getConditionById(condID, condType)
        .subscribe({
          next: condition => {
            this.payment_condition = condition.object[0].name;
            delay = condition.object[0].payment_term;
            discount = condition.object[0].discount;
          },
          complete: () => {
            if (delay > 0) { this.payment_term_date = delay };
            if (discount > 0) {
              this.payment_term_value = discount;
              this.updateAmount(this.nettoTotal*this.vatFactor, this.subtractPercentage(this.nettoTotal*this.vatFactor, this.payment_term_value));
            };
          },
          error: () => {
            return
          }
        });
    }
  }

  resetDelivery(projectID: string, deliveryID: number, positions: Delivery[]) {
    if (this.devMode) console.log('321 - reset delivery!');
    this.jobss.substractPiecesDelivered(this.jobId, positions).subscribe({
      next: () => {
        this.changeDeliveryStatus(projectID, deliveryID);
      },
      complete: () => {
        this.alertDispatcher.alertConfig.message = 'Gelieferte Positionen wurden zurückgesetzt!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
      },
      error: () => {
        return
      }
    })
  }

  updateDueDate(done: boolean) {
    this.editDueDate = false;
    this.loadInvoice(parseInt(this.praefix), parseInt(this.invoiceId));
  }

  onPaidUpdated(done: boolean) {
    this.editAmount = false;
    this.loadInvoice(parseInt(this.praefix), parseInt(this.invoiceId));
  }

  updatePositionMode(index: number, positionID: number, partID: number) {
    this.editPos = 2;
    this.positionId = positionID;
    this.partId = partID;
  }

  deletePosition(invoiceID: string, positionID: number, partID: number) {
    if (confirm('Position ' + positionID + '.' + partID + ' wirklich löschen?')) {
      this.invss.deleteInvoicePosition(invoiceID, positionID, partID)
        .subscribe({
          next: () => {
            this.loadInvoicesPositions(invoiceID);
          },
          complete: () => {
          },
          error: () => {
            return
          }
        });
    }
  }

  updateAmount(brutto: number, skonto: number) {
    this.invss.updateAmounts(this.praefix + '.' + this.invoiceId, brutto, skonto).subscribe({
      next: data => {
        if (this.devMode) console.log("Summe ist: " + this.nettoTotal);
        if (this.devMode) console.log('351 - check brutto und skonto: ' + brutto + ' ' + skonto)
      },
      complete: () => {
        this.alertDispatcher.alertConfig.message = 'Bruttosumme wurde aktualisiert.';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
      },
      error: () => {
        return
      }
    });
  }

  changeDeliveryStatus(projectID:string, deliveryID: number){
    this.delss.updateDeliveryStatus(projectID, deliveryID, 'open')
      .subscribe({
        next: () => {
          this.alertDispatcher.show({
            message: 'Status wurde geändert!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        },
        error: () => {
          this.alertDispatcher.show({
            message: 'Status konnte nicht geändert werden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
      });
  }

  changeInvoiceStatus(invoiceID: string, status: number){
    this.invss.updateInvoiceStatus(invoiceID, this.statusButtons[status].state)
      .subscribe({
        next: () => {
          this.loadInvoice(parseInt(this.praefix), parseInt(this.invoiceId));
        },
        complete: () => {
          this.alertDispatcher.alertConfig.message += ' Status wurde aktualisiert.';
          this.router.navigate(['/invoice/details/', this.praefix, this.invoiceId]);
        },
        error: () => {
          return
        }
      });
  }

  calculateDiscountDate(delay: number) {
    return moment(this.invoices.dateI).add(delay, 'days').format("DD.MM.yyyy")
  }

  calculateOpenAmount(full: number, partially: number) {
    const openAmount: number = full - partially;
    return parseFloat(openAmount.toFixed(2));
  }

  getBruttoAmount(): number {
    return parseFloat((this.nettoTotal * this.vatFactor).toFixed(2));
  }

  getSkontoAmount(): number {
    const brutto = this.getBruttoAmount();
    const skonto = Number(this.invoices.skonto ?? 0);
    if (!Number.isFinite(skonto) || skonto <= 0) {
      return brutto;
    }
    // Kompatibilität: falls noch Prozentwert geliefert wird.
    if (skonto <= 100 && brutto > 100) {
      return parseFloat((brutto * (1 - skonto / 100)).toFixed(2));
    }
    return skonto;
  }

  openSkontoAmount(): number {
    return this.calculateOpenAmount(this.getSkontoAmount(), Number(this.invoices.paid ?? 0));
  }

  openBruttoAmount(): number {
    return this.calculateOpenAmount(this.getBruttoAmount(), Number(this.invoices.paid ?? 0));
  }

  isPaymentEditable(): boolean {
    const status = (this.invoices.status || '').toLowerCase();
    return status !== 'paid' && status !== 'cancelled' && status !== 'void';
  }

  subtractPercentage(number: number, percentage: number): number {
    const decimal = percentage / 100;
    const result = number - (number * decimal);
    return result;
  }

  archivePdf() {
    if (confirm('Wollen Sie die Datei ' + 'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf archivieren?')) {
      this.safePdf();
    }

    this.alertDispatcher.show({
      message: ' Datei ' + 'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf wurde archiviert.',
      clrAlertType: IAlertType.SUCCESS
    }, 5000);
  }

  async downloadPdf(){
    if (confirm('Wollen Sie die Datei ' + 'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf wirklich herunterladen?')) {
      const documentGenerator = pdfMake.createPdf(this.documentDefinition).download('Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf');
    }

    await this.safePdf();

    this.alertDispatcher.show({
      message: 'Datei ' + 'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf wurde heruntergeladen.',
      clrAlertType: IAlertType.INFO
    }, 5000);
  }

  async printPdf() {
    if (confirm('Wollen Sie die Datei ' + 'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf ausdrucken?')) {
      pdfMake.createPdf(this.documentDefinition).print();
    }

    await this.safePdf()

    this.alertDispatcher.show({
      message: ' Datei ' + 'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf wurde an den Drucker übergeben. ',
      clrAlertType: IAlertType.INFO
    }, 5000);
  }

  safePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);
    documentGenerator.getBlob((blob: Blob) => {
      // Convert Blob to File
      const file = new File(
        [blob], // Blob content
        'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf',
        { type: blob.type, lastModified: Date.now() } // File metadata
      );

      // Now, send the file instead of the Blob
      this.filess.sendFile(file, 3, 0, this.projectId, this.jobId,'','Rechnung ' + this.invoices.praefix + '.' + this.invoices.number)
        .subscribe({
          next: () =>
          {
            if (this.devMode) console.log("done")
          },
          complete: () => {
            this.alertDispatcher.show({
              message: ' Datei ' + 'Invoice_' + this.invoices.praefix + '.' + this.invoices.number + '.pdf wurde gespeichert.',
              clrAlertType: IAlertType.SUCCESS
            }, 5000);
          },
          error: (error) => console.error("Error:", error)
        });
    });
  }

  async downloadXInv(){
    const xInvoiceGenerator = this.xinvgs.createXInvoice(this.invoices.praefix + '.' + this.invoices.number, this.invoices, this.job, this.positions, this.payment_term_date, this.payment_term_value, this.staffFirstName, this.staffLastName, this.staffEMail, this.staffPhone);

    if (confirm('Wollen Sie die XRechnung ' + 'XInvoice_' + this.invoices.praefix + '.' + this.invoices.number + '.xml wirklich speichern und herunterladen?')) {
      const blob = new Blob([xInvoiceGenerator], {type: 'application/xml'});
      const file = new File([blob], 'XInvoice_' + this.invoices.praefix + '.' + this.invoices.number + '.xml', {type: 'application/xml'});
      this.filess.sendFile(file, 3, 0, this.projectId, this.jobId,'', 'XRechnung ' + this.invoices.praefix + '.' + this.invoices.number).subscribe(
        {
          next: () => {
            saveAs(blob, 'XInvoice_' + this.invoices.praefix + '.' + this.invoices.number + '.xml')
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + 'XInvoice_' + this.invoices.praefix + '.' + this.invoices.number + '.xml wurde herunterladen.';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
          }
        }
      );
    }
  }

  async downloadZFerD(){}
}
